import React, { forwardRef } from 'react'
import { useMediaQuery } from 'react-responsive'
import { NavLink as RouterLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles'
import { Container, Typography, TextField, Button, CircularProgress, Snackbar, Slide } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert';
import LogoImg from "../../assets/images/ericssonWhite.png";
import { IAMAction } from '../../actions';
import { UnapprovedUser, LockedUser } from "../common";
import { SET_USER_DATA } from '../../constants/IAMActionTypes';
import { MigrationNotice } from '../Migration';

const responsiveData = () => {
    let desktopOrLaptop = useMediaQuery({ query: '(min-width: 1024px)' })
    let tablet = useMediaQuery({ query: '(max-width: 768px)' })
    let notMobile = useMediaQuery({ query: '(min-width: 450px)' })
    let mobile = useMediaQuery({ query: '(max-width: 450px)' })
    let portrait = useMediaQuery({ query: '(orientation: portrait)' })

    return { isDesktopOrLaptop: desktopOrLaptop, isTablet: tablet && notMobile, isMobile: mobile, isPortrait: portrait }
}

const CustomRouterLink = forwardRef((props, ref) => (<div ref={ref} style={{ flexGrow: 1 }}><RouterLink {...props} /></div>));

const snackbarTransition = (props) => { return <Slide {...props} direction="left" /> }

const validateArgs = (args, setMissing) => {
    let _missing = {}
    const keys = Object.keys(args)
    keys.map((key) => _missing[key] = args[key] === "")
    setMissing(_missing)
    let validated = false
    Object.keys(_missing).map((key) => { if (validated == false) { validated = _missing[key] } })
    return !validated
}

const LoginDesktop = ({ profile, username, setusername, password, setpassword, missing, onLogin, dispatch }) => {
    const classes = makeStyles((theme) => ({
        paper: {
            marginTop: theme.spacing(15),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        avatar: {
            margin: theme.spacing(4),
            height: theme.spacing(12),
            width: theme.spacing(12),
        },
        content: {
            width: "100%",
            marginTop: theme.spacing(5),
        },
        button: {
            margin: theme.spacing(2, 0, 0),
        },
    }))();

    return (
        <React.Fragment>
            <Container component="main" maxWidth="xs">
                <div className={classes.paper}>
                    <img className={classes.avatar} src={LogoImg} />
                    <Typography variant="h3" color='textSecondary'>Ericsson Support Portal</Typography>
                    <div className={classes.content}>
                        <TextField autoFocus required fullWidth variant="outlined" margin="normal" id="username" label="Username" error={missing['username']} value={username} onChange={(event) => setusername(event.target.value)} />
                        <TextField required fullWidth variant="outlined" margin="normal" id="password" label="password" type="password" error={missing['password']} value={password} onChange={(event) => setpassword(event.target.value)} onKeyPress={(event) => { event.key === 'Enter' ? onLogin() : null }} />
                        {profile.islocked > 0 ? <Typography variant='h5' color='error'>{3 - profile.islocked} tries left</Typography> : null}
                        <Button fullWidth variant="contained" className={classes.button} disabled={profile.status === 'WORKING'} startIcon={profile.status === 'WORKING' ? <CircularProgress size={20} /> : null} onClick={onLogin}><Typography variant="h5" style={{ color: profile.status === 'WORKING' ? '#FFFFFF' : '#000000' }}>{profile.status === 'WORKING' ? 'Please Wait' : 'Sign In'}</Typography></Button>
                        <Button fullWidth variant="contained" className={classes.button} component={CustomRouterLink} to={"/registration"} ><Typography variant="h5" style={{ color: '#000000' }}>Register</Typography></Button>
                        <Button fullWidth variant="contained" className={classes.button} component={CustomRouterLink} to={"/forgotpassword"} ><Typography variant="h5" style={{ color: '#000000' }}>Forgot Password</Typography></Button>
                    </div>
                </div>
            </Container>
            <UnapprovedUser profile={profile} />
            <LockedUser profile={profile} />
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={profile.status === "UNREGISTERED"} autoHideDuration={10000} onClose={() => IAMAction.logout(dispatch)} TransitionComponent={snackbarTransition}>
                <MuiAlert elevation={6} onClose={() => IAMAction.logout(dispatch)} variant="filled" severity={"warning"}>User is Unregistered</MuiAlert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={profile.status === "PASSWORD_ERROR"} autoHideDuration={10000} onClose={() => IAMAction.logout(dispatch)} TransitionComponent={snackbarTransition}>
                <MuiAlert elevation={6} onClose={() => dispatch({ type: SET_USER_DATA, value: { status: "LOGGED_OUT" } })} variant="filled" severity={"error"}>Incorrect Password</MuiAlert>
            </Snackbar>
        </React.Fragment>
    )
}

const LoginTablet = ({ profile, username, setusername, password, setpassword, missing, onLogin, dispatch }) => {
    const classes = makeStyles((theme) => ({
        paper: {
            marginTop: theme.spacing(10),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        avatar: {
            margin: theme.spacing(4),
            height: theme.spacing(12),
            width: theme.spacing(12),
        },
        content: {
            width: "100%",
            marginTop: theme.spacing(5),
        },
        button: {
            margin: theme.spacing(2, 0, 0),
        },
    }))();

    return (
        <React.Fragment>
            <Container component="main" maxWidth="xs">
                <div className={classes.paper}>
                    <img className={classes.avatar} src={LogoImg} />
                    <Typography variant="h3" color='textSecondary'>Ericsson Support Portal</Typography>
                    <div className={classes.content}>
                        <TextField autoFocus required fullWidth variant="outlined" margin="normal" id="username" label="Username" error={missing['username']} value={username} onChange={(event) => setusername(event.target.value)} />
                        <TextField required fullWidth variant="outlined" margin="normal" id="password" label="password" type="password" error={missing['password']} value={password} onChange={(event) => setpassword(event.target.value)} onKeyPress={(event) => { event.key === 'Enter' ? onLogin() : null }} />
                        {profile.islocked > 0 ? <Typography variant='h5' color='error'>{3 - profile.islocked} tries left</Typography> : null}
                        <Button fullWidth variant="contained" className={classes.button} disabled={profile.status === 'WORKING'} startIcon={profile.status === 'WORKING' ? <CircularProgress size={20} /> : null} onClick={onLogin}><Typography variant="h5" style={{ color: profile.status === 'WORKING' ? '#FFFFFF' : '#000000' }}>{profile.status === 'WORKING' ? 'Please Wait' : 'Sign In'}</Typography></Button>
                        <Button fullWidth variant="contained" className={classes.button} component={CustomRouterLink} to={"/registration"} ><Typography variant="h5" style={{ color: '#000000' }}>Register</Typography></Button>
                        <Button fullWidth variant="contained" className={classes.button} component={CustomRouterLink} to={"/forgotpassword"} ><Typography variant="h5" style={{ color: '#000000' }}>Forgot Password</Typography></Button>
                    </div>
                </div>
            </Container>
            <UnapprovedUser profile={profile} />
            <LockedUser profile={profile} />
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={profile.status === "UNREGISTERED"} autoHideDuration={10000} onClose={() => IAMAction.logout(dispatch)} TransitionComponent={snackbarTransition}>
                <MuiAlert elevation={6} onClose={() => IAMAction.logout(dispatch)} variant="filled" severity={"warning"}>User is Unregistered</MuiAlert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={profile.status === "PASSWORD_ERROR"} autoHideDuration={10000} onClose={() => IAMAction.logout(dispatch)} TransitionComponent={snackbarTransition}>
                <MuiAlert elevation={6} onClose={() => dispatch({ type: SET_USER_DATA, value: { status: "LOGGED_OUT" } })} variant="filled" severity={"error"}>Incorrect Password</MuiAlert>
            </Snackbar>
        </React.Fragment>
    )
}

const LoginMobile = ({ profile, username, setusername, password, setpassword, missing, onLogin, dispatch }) => {
    const classes = makeStyles((theme) => ({
        paper: {
            marginTop: theme.spacing(5),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        avatar: {
            margin: theme.spacing(4),
            height: theme.spacing(12),
            width: theme.spacing(12),
        },
        content: {
            width: "100%",
            marginTop: theme.spacing(5),
        },
        button: {
            margin: theme.spacing(2, 0, 0),
        },
    }))();

    return (
        <React.Fragment>
            <Container component="main" maxWidth="xs">
                <div className={classes.paper}>
                    <img className={classes.avatar} src={LogoImg} />
                    <Typography variant="h3" color='textSecondary'>Ericsson Support Portal</Typography>
                    <div className={classes.content}>
                        <TextField autoFocus required size='small' fullWidth variant="outlined" margin="normal" id="username" label="Username" error={missing['username']} value={username} onChange={(event) => setusername(event.target.value)} />
                        <TextField required fullWidth size='small' variant="outlined" margin="normal" id="password" label="password" type="password" error={missing['password']} value={password} onChange={(event) => setpassword(event.target.value)} onKeyPress={(event) => { event.key === 'Enter' ? onLogin() : null }} />
                        {profile.islocked > 0 ? <Typography variant='h6' color='error'>{3 - profile.islocked} tries left</Typography> : null}
                        <Button fullWidth variant="contained" size='small' className={classes.button} disabled={profile.status === 'WORKING'} startIcon={profile.status === 'WORKING' ? <CircularProgress size={20} /> : null} onClick={onLogin}><Typography variant="h5" style={{ color: profile.status === 'WORKING' ? '#FFFFFF' : '#000000' }}>{profile.status === 'WORKING' ? 'Please Wait' : 'Sign In'}</Typography></Button>
                        <Button fullWidth variant="contained" size='small' className={classes.button} component={CustomRouterLink} to={"/registration"} ><Typography variant="h5" style={{ color: '#000000' }}>Register</Typography></Button>
                        <Button fullWidth variant="contained" size='small' className={classes.button} component={CustomRouterLink} to={"/forgotpassword"} ><Typography variant="h5" style={{ color: '#000000' }}>Forgot Password</Typography></Button>
                    </div>
                </div>
            </Container>
            <UnapprovedUser profile={profile} />
            <LockedUser profile={profile} />
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={profile.status === "UNREGISTERED"} autoHideDuration={10000} onClose={() => IAMAction.logout(dispatch)} TransitionComponent={snackbarTransition}>
                <MuiAlert elevation={6} onClose={() => IAMAction.logout(dispatch)} variant="filled" severity={"warning"}>User is Unregistered</MuiAlert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={profile.status === "PASSWORD_ERROR"} autoHideDuration={10000} onClose={() => IAMAction.logout(dispatch)} TransitionComponent={snackbarTransition}>
                <MuiAlert elevation={6} onClose={() => dispatch({ type: SET_USER_DATA, value: { status: "LOGGED_OUT" } })} variant="filled" severity={"error"}>Incorrect Password</MuiAlert>
            </Snackbar>
        </React.Fragment>
    )
}

const Login = ({ profile }) => {
    const dispatch = useDispatch()
    const history = useHistory();
    const ui = useSelector((state) => state.ui);
    const responsive = responsiveData()

    const [username, setusername] = React.useState("")
    const [password, setpassword] = React.useState("")

    const [missing, setMissing] = React.useState({})

    let initialpage;
    if (ui.initialpage !== undefined && ui.initialpage.length > 0) {
        const hrefLocation = ui.initialpage.split("//")[1];
        initialpage = (hrefLocation.split("/")[1]).split("?")[0];
    } else {
        initialpage = "/";
    }

    React.useEffect(() => {
        if (profile.status === "LOGGED_IN") {
            if (history.location !== undefined && history.location.search !== '') {
                history.push({ pathname: history.location.pathname, search: history.location.search });
            } else {
                if (initialpage === '' && profile.approved === 1) {
                    initialpage = 'homepage'
                }
                history.push({ pathname: initialpage, search: '' });
            }
        }
    }, [profile.status]);

    const viewProps = {
        dispatch,
        profile, missing,
        username, setusername,
        password, setpassword,
        onLogin: () => { if (validateArgs({ username: username.length >= 7 ? username : '', password: password.length >= 8 ? password : '' }, setMissing)) { IAMAction.login(username, password, dispatch) } },
    }

    return (
        <React.Fragment>
            <MigrationNotice canMigrate={false} />
            {responsive.isMobile ? (
                <LoginMobile {...viewProps} />
            ) : responsive.isTablet ? (
                <LoginTablet {...viewProps} />
            ) : (
                <LoginDesktop {...viewProps} />
            )}
        </React.Fragment>
    )
}

export default Login
